import React from 'react';
import PropTypes from 'prop-types';

import ErrorBoundary from '../error_boundary_v1';
import PressReleasesIndex from './index';

function TopLevelIndex({
                         query, algoliaAppId, algoliaSearchKey, indexName, showMenuBar, currentUserSlug,
                       }) {
  return (
    <ErrorBoundary>
      <PressReleasesIndex
        query={query}
        algoliaAppId={algoliaAppId}
        algoliaSearchKey={algoliaSearchKey}
        indexName={indexName}
        showMenuBar={showMenuBar}
        currentUserSlug={currentUserSlug}
      />
    </ErrorBoundary>
  );
}

TopLevelIndex.propTypes = {
  query: PropTypes.string,
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  showMenuBar: PropTypes.bool,
  currentUserSlug: PropTypes.string,
};

TopLevelIndex.defaultProps = {
  query: '',
  showMenuBar: true,
  currentUserSlug: undefined,
};

export default TopLevelIndex;
